export default __webpack_public_path__ + "static/media/Mas.36761b19.jpg";